import { render, staticRenderFns } from "./HeaderOficio.vue?vue&type=template&id=52f6c1ae"
import script from "./HeaderOficio.vue?vue&type=script&lang=js"
export * from "./HeaderOficio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports